var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
function SvgLayers(props) {
    return (React.createElement("svg", __assign({ viewBox: '0 0 22 19' }, props),
        React.createElement("g", { fillRule: 'evenodd' },
            React.createElement("path", { d: 'M10.855.359L.61 6.578A.75.75 0 00.63 7.87l10.244 5.81a.75.75 0 00.754-.007l9.756-5.81a.75.75 0 00.02-1.277L11.646.367a.75.75 0 00-.792-.008zm.379 1.524l8.336 5.314-8.336 4.964-8.752-4.964 8.752-5.314z' }),
            React.createElement("path", { d: 'M20.618 11.355a.75.75 0 01.848 1.233l-.084.057-10 5.917a.75.75 0 01-.66.05l-.104-.05-10-5.917a.75.75 0 01.673-1.336l.09.046L11 17.044l9.618-5.69z' }))));
}
export default SvgLayers;
//# sourceMappingURL=Layers.js.map